export default __webpack_public_path__ + "static/countdown_birthday-f0bb75ed576062e53986207d429871e7.png";